import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { Animated, Image, View } from 'react-native';
export default function WelcomeAnimation() {
    const crusherAnimValue = useRef(new Animated.Value(0)).current;
    const editorAnimValue = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        const createAnimation = (animValue) => {
            return Animated.loop(Animated.sequence([
                Animated.timing(animValue, {
                    toValue: 1,
                    duration: 300,
                    useNativeDriver: true,
                }),
                Animated.timing(animValue, {
                    toValue: 0,
                    duration: 300,
                    useNativeDriver: true,
                }),
            ]));
        };
        const crusherAnimation = createAnimation(crusherAnimValue);
        const editorAnimation = createAnimation(editorAnimValue);
        crusherAnimation.start();
        editorAnimation.start();
        return () => {
            crusherAnimation.stop();
            editorAnimation.stop();
        };
    }, [crusherAnimValue, editorAnimValue]);
    const crusherTranslateY = crusherAnimValue.interpolate({
        inputRange: [0, 1],
        outputRange: [-5, 5],
    });
    const editorTranslateY = editorAnimValue.interpolate({
        inputRange: [0, 1],
        outputRange: [5, -5],
    });
    return (_jsxs(View, { className: "relative", children: [_jsx(Image, { source: require('@/assets/img/img_crusher_welcome_star.png'), className: "h-[184px] w-[190px]" }), _jsx(Animated.View, { style: {
                    position: 'absolute',
                    bottom: -6,
                    left: -6,
                    transform: [{ translateY: crusherTranslateY }],
                }, children: _jsx(Image, { source: require('@/assets/img/img_crusher_welcome_crusher.png'), style: { width: 102, height: 95 } }) }), _jsx(Animated.View, { style: {
                    position: 'absolute',
                    bottom: -6,
                    right: -14,
                    transform: [{ translateY: editorTranslateY }],
                }, children: _jsx(Image, { source: require('@/assets/img/img_crusher_welcome_editor.png'), style: { width: 83, height: 107 } }) })] }));
}
